import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ContractEffects } from './state/contract.effects';
import { StoreModule } from '@ngrx/store';
import { contractFeatureKey, contractReducer } from './state/contract.reducer';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(contractFeatureKey, contractReducer),
    EffectsModule.forFeature([ContractEffects])
    ],
})
export class ContractModule { }
